import { useEffect, useRef } from "react";

// Usually setInterval reads a state variable only once
// This hook helps make state changes available within setInterval functions

const useInterval = (callback, delay) => {
  const callbackRef = useRef(callback);
  const intervalRef = useRef();

  useEffect(() => (callbackRef.current = callback), [callback]);

  useEffect(() => {
    intervalRef.current = setInterval(() => callbackRef.current(), delay);
    return () => clearInterval(intervalRef.current);
  }, [delay]);
};

export default useInterval;
